import { createIsland } from 'preact-island'
import { FC } from 'preact/compat'
import { LazyMotion } from 'motion/react'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import {
  SearchDialog,
  SearchDialogProps,
} from '../components/raffle/search-dialog'

const queryClient = new QueryClient()

const RaffleSearchDialog: FC<SearchDialogProps> = ({
  searchPageUrl,
  raffleSearchUid,
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <LazyMotion
        // Async loading of the feature package reduces build size.
        features={() => import('motion/react').then((mod) => mod.domAnimation)}
      >
        <SearchDialog
          searchPageUrl={searchPageUrl}
          raffleSearchUid={raffleSearchUid}
        />
      </LazyMotion>
    </QueryClientProvider>
  )
}

createIsland(RaffleSearchDialog).render({
  selector: '[data-island="raffle-search-dialog"]',
  initialProps: {
    raffleSearchUid: process.env.RAFFLE_SEARCH_UID,
    searchPageUrl: '/',
  },
})
